import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('diseaseListingSection', {
    id: {
        title: 'ID',
        type: 'string',
        hidden: true
    }
});
var validator = z.object({
    id: z.string()
}).partial();
schema.diseaseListingSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=diseaseListingSection.js.map